import Vue from 'vue/dist/vue.esm.js';
import gsap from 'gsap';

let parent = document.getElementById('#beforeAndAfterWrapper');

// DUMMY DATA
let data = [
  {
    before: 'https://via.placeholder.com/500x600?text=Before',
    after: 'https://via.placeholder.com/500x600?text=After',
  },
  {
    before: 'https://via.placeholder.com/500x600?text=Before',
    after: 'https://via.placeholder.com/500x600?text=After',
  },
  {
    before: 'https://via.placeholder.com/500x600?text=Before',
    after: 'https://via.placeholder.com/500x600?text=After',
  },
  {
    before: 'https://via.placeholder.com/500x600?text=Before',
    after: 'https://via.placeholder.com/500x600?text=After',
  }
]

Vue.component('before-and-after', {
  data() {
    return {
      activeIndex: 0,
      timeout: null,
      isScrolling: false
    }
  },
  props: {
    images: {
      type: Array,
      required: true,
      default: ()=>{
        return data;
      }
    }
  },
  mounted(){
    this.setupIntersection();
  },
  methods: {
    setActiveIndex: function(index){
      this.activeIndex = index;
    },
    setupIntersection: function(){
      this.imageEls = document.querySelectorAll(".before-and-after__images__el");
      const options = {
        root: document.querySelector('.before-and-after__images'),
        rootMargin: '0px',
        threshold: 0.01
      }
      const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting && !this.isScrolling) {
            this.scrollToAndUpdateIndex(entry.target.dataset.imagesIndex);
          }
        });
      }, options);

      this.imageEls.forEach((el)=>{
        observer.observe(el);
      })
    },

    scrollToAndUpdateIndex: function(index){
      this.isScrolling = true;
      let container = document.querySelector('.before-and-after__images');
      let offset = container.offsetLeft;
      let selectedIndex = document.querySelector(`[data-images-index="${index}"]`);
      let start = {scroll: container.scrollLeft};
      let end = selectedIndex.offsetLeft - offset; //37 is the padding offset

      gsap.to(start,{duration:0.5, scroll:end, ease:'power3.InOut',
        onUpdate: ()=>{
          container.scrollLeft = start.scroll;
        },
        onComplete: ()=>{
          this.isScrolling = false;
        }
      })

      this.setActiveIndex(index);
    },

    nextSlide(direction){

      let tempIndex = parseInt(this.activeIndex);

       tempIndex += direction ? 1 : -1;

      if(tempIndex > this.imageEls.length - 1){
        tempIndex = 0
      }

      if(tempIndex < 0){
        tempIndex = this.imageEls.length-1
      }

      this.scrollToAndUpdateIndex(tempIndex)
    }

  }
});

new Vue({}).$mount('#beforeAndAfterWrapper');
